// Vue
import { Vue, Component, Prop, Inject, Watch } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { ImageAspectRatio } from "../../../../components/image_aspect_ratio/ImageAspectRatio";
import { Observer } from "mobx-vue";
import {
  BodyBuilder,
  Pagination,
} from "#/common/interfaces/conversionworld/BodyBuilder";

// Enums
import { LoadMoreButton } from "../../../../components/load_more_button/LoadMoreButton";
import { Api } from "../../../../api";
import { BodybuilderLink } from "../bodybuilder_link/BodybuilderLink";
import { VanPartnerLink } from "../van_partner_link/VanPartnerLink";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ImageAspectRatio,
    LoadMoreButton,
    BodybuilderLink,
    VanPartnerLink,
  },
})
export class BodybuilderList extends Vue {
  @Prop({ default: "default" })
  private theme!: string;

  @Prop({ default: "" })
  private loadMoreVanSolutionText!: string;

  @Prop({ default: "" })
  private loadMoreVanPartnerText!: string;

  @Prop({ default: false })
  private order!: boolean;

  private vanSolutions: BodyBuilder[] = [];

  private vanPartners: BodyBuilder[] = [];

  private isLoadingMoreVanSolutionProducts: boolean = false;

  private isLoadingMoreVanPartnerProducts: boolean = false;

  private solutionsPagination: Pagination = { epp: 20, number: 1 };
  private partnersPagination: Pagination = { epp: 20, number: 1 };

  public get filter() {
    return this.$store.conversionWorldProductFilter.filterWithPageId;
  }

  public get filterQuery() {
    return this.filter.query;
  }

  @Watch("filterQuery")
  public onFilterQueryChange() {
    this.reloadPageListData();
  }

  public get hasMoreVanSolutionProducts() {
    if (this.solutionsPagination) {
      return (
        this.solutionsPagination.number < this.solutionsPagination.page_count!
      );
    } else {
      return false;
    }
  }

  public get hasMoreVanPartnerProducts() {
    if (this.partnersPagination) {
      return (
        this.partnersPagination.number < this.partnersPagination.page_count!
      );
    } else {
      return false;
    }
  }

  async created() {
    await this.reloadPageListData();
    this.$eventBus.$on(
      "conversion-world-close-filter",
      this.reloadPageListData
    );
  }

  public beforeDestroy() {
    this.$eventBus.$off(
      "conversion-world-close-filter",
      this.reloadPageListData
    );
  }

  private reloadPageListData() {
    return Promise.all([this.loadVanSolutions(), this.loadVanPartners()]);
  }

  private async loadVanSolutions() {
    const { resultList, pagination } =
      await Api.conversionWorldService.getBodyBuilders(
        "vansolution",
        this.filter,
        this.solutionsPagination
      );

    this.vanSolutions = this.sortResultList(resultList);
    this.solutionsPagination = pagination!;
    this.$store.conversionWorld.vanSolutionBodybuilderTotalCount =
      pagination!.total_count || 0;
  }

  private async loadVanPartners() {
    const { resultList, pagination } =
      await Api.conversionWorldService.getBodyBuilders(
        "vanpartner",
        this.filter,
        this.partnersPagination
      );
    this.vanPartners = this.sortResultList(resultList);
    this.partnersPagination = pagination!;
    this.$store.conversionWorld.vanPartnerBodybuilderTotalCount =
      pagination!.total_count || 0;
  }

  private sortResultList(bodybuilders: BodyBuilder[]) {
    if (this.order) {
      return bodybuilders.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
    }

    return bodybuilders;
  }

  public async loadMoreVanSolutionProducts() {
    this.isLoadingMoreVanSolutionProducts = true;

    this.solutionsPagination.number += 1;
    const { resultList, pagination } =
      await Api.conversionWorldService.getBodyBuilders(
        "vansolution",
        this.filter,
        this.solutionsPagination
      );

    this.vanSolutions = this.vanSolutions.concat(
      this.sortResultList(resultList)
    );
    this.$store.conversionWorld.vanSolutionBodybuilderTotalCount =
      pagination!.total_count || 0;
    this.solutionsPagination = pagination!;

    this.isLoadingMoreVanSolutionProducts = false;
  }

  public async loadMoreVanPartnerProducts() {
    this.isLoadingMoreVanPartnerProducts = true;

    this.partnersPagination.number += 1;
    const { resultList, pagination } =
      await Api.conversionWorldService.getBodyBuilders(
        "vanpartner",
        this.filter,
        this.partnersPagination
      );

    this.vanPartners = this.vanPartners.concat(this.sortResultList(resultList));
    this.$store.conversionWorld.vanPartnerBodybuilderTotalCount =
      pagination!.total_count || 0;
    this.partnersPagination = pagination!;

    this.isLoadingMoreVanPartnerProducts = false;
  }
}
